<template>
  <div class="flex">
    <span
      v-if="
        badgeProps.variant === 'perGroupUpTo' && badgeProps.maxPeople != null
      "
      class="text-label text-gray-500"
    >
      {{
        t('product.show.checkout.perGroupUpTo', { max: badgeProps.maxPeople })
      }}
    </span>
    <Badge
      v-else-if="badgeProps.variant === 'multidate'"
      class="bg-teal-50 text-primary m-0"
    >
      {{
        t('product.show.checkout.multidateBadge', {
          count: badgeProps.sessionCount,
        })
      }}
    </Badge>
  </div>
</template>

<script lang="ts" setup>
import type { BadgeProps } from '~/composables/eventBuyBoxPrice'

defineProps<{
  badgeProps: BadgeProps
}>()

const { t } = useI18n()
</script>
